import { OfferApiState, OrderType } from '../constants';
import { IPlainObject } from './plain-object';

export enum FilterPeriodType {
  AllTime = 'all',
  Today = 'today',
  Yesterday = 'yesterday',
  Last3 = 'last3',
  Last7 = 'last7',
  Last30 = 'last30',
  Last90 = 'last90',
  Last180 = 'last180',
  LastYear = 'lastYear',
  CurrentMonth = 'currentMonth',
  PreviousMonth = 'previousMonth',
  Period = 'period',
}

export enum DataFiltersModelField {
  DateFrom = 'dateFrom',
  DateTo = 'dateTo',
  DatePeriod = '_datePeriod',
  Country = 'country',
  AndroidVersion = 'androidVersion',
  AppVersion = 'appVersion',
  PerPage = 'perPage',
  Page = 'page',
  Partners = 'partners',
  Packages = 'packages',
  OrderColumn = 'orderColumn',
  OrderType = 'orderType',
  OneDay = 'oneDay',
  Offers = 'offers',
  FilterByUsers = 'filterByUsers',
  FilterByActive = 'filterByActive',
}

export interface DateFiltersModel {
  [DataFiltersModelField.DateFrom]?: string;
  [DataFiltersModelField.DateTo]?: string;

  [DataFiltersModelField.DatePeriod]?: FilterPeriodType;
}

export interface FiltersBaseModel extends DateFiltersModel {
  country?: string | string[];
  androidVersion?: string;
  appVersion?: string;
}

export interface DataFiltersModel extends FiltersBaseModel {
  perPage?: number;
  page?: number;
  orderColumn?: string;
  orderType?: OrderType;
  oneDay?: boolean;
  filterByUsers?: string | string[];
  publisher?: string;
  filterByActive?: OfferApiState;
  offers?: string | string[];
  partners?: string | string[];
  partnerIds?: string[];
  packages?: string | string[];
}

export interface PaginationBaseModel extends DataFiltersModel {
  total: number;
}

export interface PaginationModel<T = IPlainObject> extends PaginationBaseModel {
  data: T[];
}

export interface PaginationTopDataModel<T = IPlainObject>
  extends PaginationModel<T> {
  topData: T[];
}

export interface PaginationDateModel<T = IPlainObject>
  extends DateFiltersModel {
  data: T;
}

export interface PaginationFiltersModel<T = IPlainObject>
  extends PaginationBaseModel {
  data: T;
}
